var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron",class:{ 
    'jumbotron-layout--left': _vm.layout, 
    'google-style': _vm.googleStyle,
    'is-gray': _vm.isGray
  }},[(_vm.topTitle)?_c('h4',{staticClass:"jumbotron-toptitle"},[_vm._v(_vm._s(_vm.topTitle))]):_vm._e(),(_vm.title)?_c('h1',{staticClass:"jumbotron-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("subtitle",function(){return [(_vm.subtitle)?_c('h4',{staticClass:"jumbotron-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]}),_c('div',{class:{ container: _vm.container }},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }